import type { UserRole } from '@mairistem/finances-utils';
import React from 'react';
import PreviousPeriodeModal from '../../components/simulation/Outils/Periode/PreviousPeriodeModal';
import TypePeriode from '../../constants/simulation/typePeriode';
import type Simulation from '../../interfaces/simulation/simulation';
import BaseOutil from './BaseOutil';

const getPeriodeTitle = (simulation: Simulation): string => {
	if (simulation?.transfertCpta) {
		return 'Revenir en vote par l’assemblée';
	}

	switch (simulation?.typePeriode) {
		case TypePeriode.PROPOSE:
			return 'Revenir en recensement des demandes';
		case TypePeriode.VOTE:
			return 'Revenir en formulation des propositions';
		default:
			return '';
	}
};

class PreviousPeriode extends BaseOutil {
	isDemandeEnabled = false;

	constructor(simulation: Simulation, isDemandeEnabled: boolean) {
		super();
		this.code = 'PRE_PER';
		this.isDemandeEnabled = isDemandeEnabled;
		this.icon = { iconSet: 'Lucide', name: 'ArrowLeftFromLine' };
		this.title = getPeriodeTitle(simulation);
	}

	isEnabled(userRole: UserRole, simulation: Simulation): boolean {
		const hasAccess = super.isEnabled(userRole, simulation);

		switch (simulation?.typePeriode) {
			case TypePeriode.DEMANDE:
				// Il n'y a pas de periode avant le demande
				return false;
			case TypePeriode.PROPOSE:
				return this.isDemandeEnabled && hasAccess;
			case TypePeriode.VOTE:
				return hasAccess;
			case TypePeriode.CA_CFU:
				return hasAccess && simulation?.transfertCpta;
			default:
				return false;
		}
	}

	renderModal(
		simulation: Simulation,
		onClose: () => void,
		onValidate: (typePeriode: TypePeriode) => void,
		open: boolean,
	) {
		return (
			<PreviousPeriodeModal
				onClose={onClose}
				onValidate={onValidate}
				open={open}
				simulation={simulation}
				title={this.title}
			/>
		);
	}
}

export default PreviousPeriode;
